module.exports = __webpack_public_path__ + "img/error-offer-loading.198a321d.svg";